// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-qklt","clinicsSelect":"styles_clinicsSelect__2rhxJ"};